import React, { useMemo, useContext } from 'react';

import { SingleQuestionController } from '@sm/question-widgets/respondent-survey';
import { ExternalQuestion } from '@sm/question-definitions';
import { SurveyFormatView, SurveyFormatViewRenderProps } from '~app/components/Survey/SurveyFormat';
import groupQuestionsWithLayoutConfig from './utils';
import { QuestionRowLayout } from '../QuestionRowLayout';
import { QuestionAnswers } from '../../types';
import { CurrentPageContext } from '../../CurrentPageContext';

export type Props = {
  questions: ExternalQuestion[];
  answers: QuestionAnswers;
  /** Checks if the question coming in is OQAAT is default set to true */
  isOQAAT?: boolean;
};

function QuestionList({ questions, answers, isOQAAT = true }: Props): React.ReactElement {
  const { registerValidator, unregisterValidator, questionAnswerErrors } = useContext(CurrentPageContext);

  const groups = useMemo(() => groupQuestionsWithLayoutConfig(questions), [questions]);

  return (
    <>
      {groups.map(group => (
        <QuestionRowLayout maxQuestionsPerRow={isOQAAT ? 1 : 4} key={`group_${group.map(g => g.id).concat('-')}`}>
          {group.map(question => (
            <SurveyFormatView name={question.id} key={question.id}>
              {({ isActive, setNextActive }: SurveyFormatViewRenderProps) => (
                <SingleQuestionController
                  {...{ question }}
                  displayOptions={{
                    answer: answers[question.id],
                    onSubmit: setNextActive,
                    active: isActive,
                    registerValidator,
                    unregisterValidator,
                    errors: questionAnswerErrors(question.id),
                  }}
                />
              )}
            </SurveyFormatView>
          ))}
        </QuestionRowLayout>
      ))}
    </>
  );
}

export default QuestionList;
